import { deburr } from 'lodash-es'
import { normalizeForSearch } from './search-helpers'

const urlEncodeRegexReplacements = [
  [/\s|%20/g, '-'],
  [/%c3%a0/g, 'a'],
  [/%c3%a7/g, 'c'],
  [/%c3%a9|%c3%a8|%c3%aa|%c3%89/g, 'e'],
  [/%c3%ae|%c3%8e/g, 'i'],
  [/%c3%b4/g, 'o'],
  [/%c3%b9/g, 'u'],
  [/%27|%cc%80|%cc%81|%c2%ab|%c2%bb/g, ''],
  [/-+/g, '-']
]

const contentRegexReplacements = [
  [/font-size:[\d.]+pt;?/g, ''],
  [/font-family:[^"]+serif;?/g, ''],
  [/("|;)color:[^"]+;?/g, '$1'],
  [/("|;)background-color:[^"]+;?/g, '$1'],
  [/<p>&nbsp;<\/p>/g, ''],
  [/<p><\/p>/g, ''],
  [/\/sites\/icea\.qc\.ca\/files\/field\/image\/([^"]+)/g, 'https://backend.icea.qc.ca/wp-content/uploads/2025/08/$1'],
  [/(\/wp-content\/uploads\/2025\/08\/)([^",]+)("|,)/g, ($m, $1, $2, $3) => `${$1}${formatUrl($2)}${$3}`]
]

export function formatContent(content) {
  return contentRegexReplacements.reduce(
    (cleaned, [pattern, replacement]) => cleaned.replace(pattern, replacement),
    content
  )
}

export function formatUrl(url, replaceHost) {
  const accUrl = replaceHost
    ? url
        .toLowerCase()
        .replace(
          /https:\/\/icea\.qc\.ca\/(?:[^/]+\/)+([^"]+)/g,
          'https://backend.icea.qc.ca/wp-content/uploads/2025/08/$1'
        )
    : url.toLowerCase()

  return urlEncodeRegexReplacements.reduce(
    (cleaned, [pattern, replacement]) => cleaned.replace(pattern, replacement),
    deburr(accUrl)
  )
}

export function getReadingTime(content = '') {
  if (!content) return null
  const words = normalizeForSearch(content).replace(/\s\./, '').trim().split(/\s+/).length
  return Math.ceil(words / 225)
}
